interface _AnuncioDetalle {
  id: number | null;
  tipo_anuncio_id: number | null;
  largo: number | null;
  ancho: number | null;
  caras: number | null;
  pieza: number | null;
  mes: number | null;
  dia: number | null;
  movimiento_rotatorio: any
}

export class AnuncioDetalle implements _AnuncioDetalle {
  [key: string]: number | string | null | File[] | any;
  id = null;
  tipo_anuncio_id: number = 0;
  largo: number = 0;
  ancho: number = 0;
  caras: number = 0;
  pieza: number = 0;
  mes: number = 0;
  dia: number = 0;
  movimiento_rotatorio: any;
}